var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSerialNumber24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49274 7.18945C7.76888 7.18945 7.99274 7.41331 7.99274 7.68945V16.895C7.99274 17.1711 7.76888 17.395 7.49274 17.395C7.21659 17.395 6.99274 17.1711 6.99274 16.895V7.68945C6.99274 7.41331 7.21659 7.18945 7.49274 7.18945Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0034 7.18945C10.2796 7.19032 10.503 7.41487 10.5025 7.69102L10.4923 13.1754C10.4918 13.4515 10.2675 13.6747 9.99135 13.6738C9.71521 13.673 9.49177 13.4484 9.49229 13.1723L9.5025 7.68789C9.50302 7.41175 9.72729 7.18859 10.0034 7.18945Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5025 7.18945C12.7786 7.18945 13.0025 7.41331 13.0025 7.68945V16.895C13.0025 17.1711 12.7786 17.395 12.5025 17.395C12.2264 17.395 12.0025 17.1711 12.0025 16.895V7.68945C12.0025 7.41331 12.2264 7.18945 12.5025 7.18945Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0132 7.18945C15.2893 7.19032 15.5128 7.41487 15.5123 7.69102L15.502 13.1754C15.5015 13.4515 15.2773 13.6747 15.0011 13.6738C14.725 13.673 14.5015 13.4484 14.5021 13.1723L14.5123 7.68789C14.5128 7.41175 14.7371 7.18859 15.0132 7.18945Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9989 17.3945C14.7228 17.3925 14.5005 17.1671 14.5025 16.891L14.5123 15.5258C14.5143 15.2496 14.7397 15.0274 15.0158 15.0293C15.292 15.0313 15.5142 15.2568 15.5123 15.5329L15.5025 16.8981C15.5005 17.1742 15.2751 17.3965 14.9989 17.3945Z",
    fill: "#141414"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97939 17.3945C9.70326 17.3925 9.48101 17.1671 9.48298 16.891L9.49275 15.5258C9.49472 15.2496 9.72018 15.0274 9.99631 15.0293C10.2724 15.0313 10.4947 15.2568 10.4927 15.5329L10.483 16.8981C10.481 17.1742 10.2555 17.3965 9.97939 17.3945Z",
    fill: "#141414"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5123 7.18945C17.7884 7.18945 18.0123 7.41331 18.0123 7.68945V16.895C18.0123 17.1711 17.7884 17.395 17.5123 17.395C17.2361 17.395 17.0123 17.1711 17.0123 16.895V7.68945C17.0123 7.41331 17.2361 7.18945 17.5123 7.18945Z",
    fill: "#141414"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5025 4.85742H4.5025V19.7285H20.5025V4.85742ZM4.5025 3.85742C3.95022 3.85742 3.5025 4.30514 3.5025 4.85742V19.7285C3.5025 20.2808 3.95022 20.7285 4.5025 20.7285H20.5025C21.0548 20.7285 21.5025 20.2808 21.5025 19.7285V4.85742C21.5025 4.30514 21.0548 3.85742 20.5025 3.85742H4.5025Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSerialNumber24);
export default __webpack_public_path__ + "static/media/icon_serial_number_24.d77d21f775d00c632bd7875d0c952c56.svg";
export { ForwardRef as ReactComponent };